module.exports = __webpack_public_path__ + "static/media/icon-hamburger.d98c1990.svg";